import {
  CATEGORIE_UNITAIRE,
  CATEGORIE_REGROUPEMENT,
  CATEGORIE_REGROUPEMENT_LC,
  CATEGORIE_LOCATION,
  CATEGORIE_DIVERS,
  CATEGORIE_REGROUPEMENT_NUMERIQUE,
  CATEGORIE_ECRAN_NUMERIQUE,
} from '@/configuration/produitConf';
import {
  ETAT_SANS_SUITE,
  ETAT_ENREGISTRE,
  ETAT_FACTURE,
  ETAT_CLOS,
  ETAT_FACTURE_PARTIELLEMENT,
  ETAT_COMMANDE_PARTIELLEMENT,
} from '@/configuration/devisConf';

export const COMMANDE_ETAT = [{
  id: 0,
  text: 'Actif',
},
{
  id: 1,
  text: 'Facturée',
},
{
  id: 2,
  text: 'Facturée partiellement',
},
{
  id: 3,
  text: 'Sans suite',
},
{
  id: 4,
  text: 'Clos',
},
{
  id: 5,
  text: 'Commandé partiellement',
}];

export const COMMANDE_ETAT_AFFIXE2 = [{
  id: ETAT_ENREGISTRE,
  text: 'Actif',
},
{
  id: ETAT_FACTURE,
  text: 'Facturée',
},
{
  id: ETAT_FACTURE_PARTIELLEMENT,
  text: 'Facturée partiellement',
},
{
  id: ETAT_SANS_SUITE,
  text: 'Sans suite',
},
{
  id: ETAT_CLOS,
  text: 'Clos',
},
{
  id: ETAT_COMMANDE_PARTIELLEMENT,
  text: 'Commandé partiellement',
}];

export const COMMANDE_TYPE = [{
  id: 0,
  text: 'Proposition',
},
{
  id: 1,
  text: 'Commande',
}];

export const COMMANDE_TYPE_AFFIXE2 = [{
  id: 1,
  text: 'Commande',
}];

export const COMMANDE_CATEGORIE = [{
  id: 0,
  text: 'Tempo',
},
{
  id: 1,
  text: 'Lc',
},
{
  id: 2,
  text: 'Libre',
},
{
  id: 3,
  text: 'Reseaux lc',
}];

export const COMMANDE_CATEGORIE_AFFIXE2 = [{
  id: CATEGORIE_REGROUPEMENT,
  text: 'Réseaux temporaire',
},
{
  id: CATEGORIE_UNITAIRE,
  text: 'LC',
},
{
  id: CATEGORIE_DIVERS,
  text: 'Libre',
},
{
  id: CATEGORIE_REGROUPEMENT_LC,
  text: 'Reseaux lc',
},
{
  id: CATEGORIE_LOCATION,
  text: 'Location',
},
{
  id: CATEGORIE_ECRAN_NUMERIQUE,
  text: 'Ecran numérique',
},
{
  id: CATEGORIE_REGROUPEMENT_NUMERIQUE,
  text: 'Réseau numérique',
}];



// WEBPACK FOOTER //
// ./src/components/mesOpportunites/configuration/commandeConf.js